



















import {Component, Vue} from 'vue-property-decorator';
import PageSeparator from '../../../components/vui-luma/Ui/PageSeparator.vue';
import EventCard from '../../../components/Events/EventCard.vue';
import videojs from 'video.js';
import {dispatchGetNewsDetailed} from '@/store/news/actions';
import {readNewsDetailed} from '@/store/news/getters';
// @ts-ignore
import logo from '@/assets/images/logo.png';
import {readUserProfile} from '@/store/main/getters';
import {dispatchGetUserProfile, dispatchRouteLoggedIn} from '@/store/main/actions';

@Component({
  components: {
      EventCard,
      PageSeparator,
  },
})
export default class NewsView extends Vue {
  public logo = logo;

  public async created() {
    await dispatchGetNewsDetailed(this.$store, {pk: this.$router.currentRoute.params.id});
    const newsDetailed = readNewsDetailed(this.$store);
    if (!newsDetailed) {
      this.$router.push('/news');
    }
  }
  get newsDetailed() {
    return readNewsDetailed(this.$store);
  }

}
